import useAppStore from "@/store"

export default function StorageErrorBanner() {
  const storageError = useAppStore((s) => s._storageError)

  if (!storageError) return null

  return (
    <div role="alert" aria-live="polite">
      <p>
        Warning: your progress may not be saved. Storage is unavailable 
        ({storageError}). Please ensure you are not in private browsing mode 
        and that your device has sufficient storage.
      </p>
    </div>
  )
}